import React from 'react'
import { Link } from "react-router-dom";
import HomeBlog from '../home/HomeBlog';


const Blog = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>हमारा ब्लॉग</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                                <li className="breadcrumb-item">हमारा ब्लॉग</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>
            <section className="content-inner-3">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 pe-xl-5 m-b30">
                            <div className="dz-blog blog-single sidebar style-1">
                                <div className="dz-info">
                                    <div className="dz-post-text">
                                        <img src="./assets/img/corona_banner-1.jpg" alt="/"/>
                                        <p className='mt-lg-5'>हमारे अस्पताल में, आपकी सेहत और सुरक्षा हमारी सबसे बड़ी प्राथमिकता है। कोरोनावायरस संक्रमण, जो 'सीवियर एक्यूट रेस्पिरेटरी सिंड्रोम कोरोनावायरस 2' (SARS-CoV-2) की वजह से होता है, सांस से निकलने वाली बूंदों और करीबी संपर्क से आसानी से फैल सकता है। बचाव के आसान तरीकों को अपनाकर हम खुद को, अपने परिवार को और अपने समुदाय को सुरक्षित रख सकते हैं।</p>
                                        <blockquote className="wp-block-quote is-style-default">
                                            <p>हमारा अस्पताल COVID-19 के फैलने के जोखिम को कम करने के लिए संक्रमण रोकने के कड़े नियमों का पालन करता है, जिसमें नियमित सैनिटाइज़ेशन, स्क्रीनिंग की प्रक्रियाएं और मरीज़ों की सुरक्षा के उपाय शामिल हैं।</p>
                                            <cite>सुरक्षा के प्रति हमारी प्रतिबद्धता</cite>
                                            {/* <i className="flaticon-right-quote" /> */}
                                        </blockquote>
                                       
                                        <h3 className="dz-title">टीका लगवाएं</h3>
                                        <p>कोविड-19 से गंभीर बीमारी, अस्पताल में भर्ती होने और जटिलताओं के जोखिम को कम करने के लिए टीकाकरण सबसे असरदार तरीकों में से एक है। हेल्थकेयर अधिकारियों की सलाह के अनुसार बूस्टर डोज़ लेते रहें।</p>
                                        <h3 className="dz-title">हाथों की साफ़-सफ़ाई का ध्यान रखें</h3>
                                        <p>अपने हाथों को साबुन और पानी से कम से कम 20 सेकंड तक बार-बार धोएं। जब साबुन और पानी उपलब्ध न हों, तो अल्कोहल-बेस्ड हैंड सैनिटाइज़र (कम से कम 60% अल्कोहल वाला) इस्तेमाल करें। अपने चेहरे, खासकर आंखों, नाक और मुंह को छूने से बचें।</p>
                                        <h3 className="dz-title">ज़रूरत पड़ने पर मास्क पहनें</h3>
                                        <p>भीड़-भाड़ वाली बंद जगहों या हेल्थकेयर जगहों पर मास्क पहनें। पक्का करें कि मास्क आपकी नाक और मुंह दोनों को अच्छी तरह से ढके। डिस्पोज़ेबल मास्क को नियमित रूप से बदलें और दोबारा इस्तेमाल होने वाले मास्क को रोज़ धोएं।</p>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <HomeBlog />
        </>
    )
}

export default Blog